// extracted by mini-css-extract-plugin
module.exports = {"shippingTitle":"_1rQmF"};